module.exports = "<div layout=\"row\" class=\"wrapper\">\n\n  <h1>{{guide.title}}</h1>\n  <p>\n    {{guide.subtitle}}\n  </p>\n</div>\n"